module.exports = __webpack_public_path__ + "static/img/image_solutions_optics_06.b851e3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_optics_06.png
// module id = IkqL
// module chunks = 10